module.exports = __webpack_public_path__ + "static/4-5844f8e94d4b39ebe1d7e138676a1f74.webp";